<template>
    <v-container>
        <v-row >
            <v-col cols="12">
                <v-card>
                    <v-row  class="dialog-action-buttons">
                        <v-col cols="12" sm="6" v-if="!auth.currentUserIsReadOnly()">
                            <v-btn
                                block
                                color="success"
                                @click="routeToNewSpecimen"
                            >
                                Add New Specimen
                            </v-btn>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-btn
                                block
                                color="accent"
                                @click="routeToDailyHusbandry"
                            >
                                Daily Husbandry
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12">
                <dashboard></dashboard>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import * as auth from '@/services/auth';
import Dashboard from "@/components/dashboard/Dashboard";

export default {
    components: {
        Dashboard
    },
    props: [
        
    ],
    data() {
        return {
            auth: auth
        };
    },
    computed: {
        
    },
    methods: {
        routeToDailyHusbandry() {
            this.$router.push({ name: "husbandry" });
        },
        routeToNewSpecimen() {
            this.$router.push({ name: "specimens", params: { openNewSpecimen: true } });
        }
    }
};
</script>

<style>
    
</style>